<!--suppress ALL -->
<template lang="pug">
//- Die Sidebar ist nun ein Geschwister-Element zum Pusher
div#app-wrapper
    //- Modal bei abgelaufener Sitzung
    session-expired-modal

    //- Top-Navigation (fixed)
    top-navigation(
        v-if='!hideNavigation && !isLogin && !isLogout'
        :is-expanded="isExpanded"
        @toggle="toggleSidebar"
    )

    //- Navigation
    navigation(
        v-if='!hideNavigation && !isLogin && !isLogout'
        :is-expanded="isExpanded"
        @toggle="toggleSidebar"
    )

    //- Der Pusher enthält den gesamten restlichen Inhalt
    div.pusher(:class="{ 'expanded': isExpanded, 'full-width': hideNavigation || isLogin || isLogout }")
        
        //- Deine Modals und Loader bleiben hier
        .ui.fatal.fullscreen.modal
            .header
                i.bug.icon
                | Unerwarterter Fehler
            .content
                p Leider ist unerwarteter Fehler aufgetreten, sorry. Bitte den untenstehenden Text kopieren und mit kleiner Fehlerbeschreibung an den Support senden. Vielen Dank!
                .ui.form
                    .field
                        textarea.error-code(readonly)
            .actions
                .ui.positive.right.labeled.icon.button
                    | Habe ich gemacht!
                    i.checkmark.icon
            
        .ui.inverted.active.page.dimmer(v-show='isLoading && isInitialLoad')
            .ui.text.primary.elastic.loader Inhalt wird geladen

        .ui.primary.top.attached.sliding.indeterminate.progress(v-show='showLoadingBar && !isInitialLoad')
            .bar
                .progress

        //- Der eigentliche Content im Grid
        div.ui.fluid.grid#app-root
            div.sixteen.wide.column
                router-view(@toggle="toggleSidebar")
</template>

<script>
    import Navigation from './components/app/Navigation.vue'
    import TopNavigation from './components/app/TopNavigation.vue'
    import SessionExpiredModal from './components/app/SessionExpiredModal.vue'

    export default {
        name: 'app',

        components: {
            Navigation,
            TopNavigation,
            SessionExpiredModal
        },

        computed: {

            hideNavigation() {
                return this.$route.meta.hideNavigation === true
            },

            isLogin() {
                return this.$route.name === 'app/login'
            },

            isLogout() {
                return this.$route.name === 'app/logout'
            },

            isLoading() {
                return this.$http.isLoading
            },

        },

        data() {
            return {
                serverError: '',
                showLoadingBar: false,
                isInitialLoad: true,
                isExpanded: false // Steuert das Ein-/Ausklappen der Sidebar
            }
        },

        created() {
            this.$loadingTimer = null
        },

        watch: {
            isLoading(val) {
                if (val) {
                    this.$loadingTimer = setTimeout(() => { this.showLoadingBar = true }, 1000)
                } else {
                    clearTimeout(this.$loadingTimer)
                    this.showLoadingBar = false
                    this.isInitialLoad = false
                }
            }
        },

        methods: {
            toggleSidebar() {
                this.isExpanded = !this.isExpanded;
            },
            showVersion() {
                alert(123)
            }
        }
    }

</script>

<style>
    /* Sidebar-Fix: Verhindert das "Überlappen" und nutzt Margin statt Transform */
    .ui.visible.left.sidebar ~ .pusher {
        transform: translate3d(0, 0, 0) !important;
    }

    .pusher {
        /* Standardabstand für die Mini-Sidebar (70px) */
        margin-left: 40px !important;
        transition: margin-left 0.3s ease, width 0.3s ease !important;
        width: calc(100% - 40px) !important;
        min-height: 100vh !important;
        padding-bottom: 1rem;
    }

    /* Wenn keine Navigation da ist (Login/Logout), Pusher auf volle Breite */
    .pusher.full-width {
        margin-left: 0 !important;
        width: 100% !important;
    }

    /* Falls deine Sidebar die Klasse 'expanded' bekommt, muss der Pusher weichen */
    /* Hinweis: Die Klasse .expanded sollte an das Sidebar-Element in Navigation.vue */
    .ui.sidebar.expanded ~ .pusher {
        margin-left: 240px !important;
        width: calc(100% - 240px) !important;
    }

    #app-root {
        padding-top: 5rem;
        padding-left: 2rem;
        padding-right: 2rem;
    }

    .ui.top.attached.progress {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        z-index: 9999;
        pointer-events: none;
    }

    .error-code {
        font-family: monospace;
    }

    .ui.icon.message > i.icon:not(.close) {
        font-size: 1.5em;
    }
</style>

